/** Service-worker registration and the update state (06 §15.3). */
import { pwaState } from './state';

export { pwaState } from './state';

/** Registers the service worker (production builds only; dev and unit tests skip it). */
export async function registerServiceWorker(): Promise<void> {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }
  const { registerSW } = await import('virtual:pwa-register');
  // its returned update function waits for a `controlling` event that may never come: see applyUpdate.ts
  registerSW({
    immediate: true,
    onNeedRefresh: () => {
      pwaState.value = { ...pwaState.value, needRefresh: true };
    },
    onOfflineReady: () => {
      pwaState.value = { ...pwaState.value, offlineReady: true };
    },
  });
}

export { applyUpdate } from './applyUpdate';

/** Test hook: behave as if a new worker were waiting (06 §17.2, AC-PWA-04). */
export function simulateUpdate(): void {
  pwaState.value = { ...pwaState.value, needRefresh: true };
}
